import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignsNewHandoff } from '@/pages/workspaces/automations/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/automations/new` URL, which existing create links use. Flag off the
 * embedded app serves it; flag on it forwards to the migrated URL.
 */
function JourneysAutomationsNewRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysCampaignsNewHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/automations/new')({
  component: JourneysAutomationsNewRoute,
});
